<div class="flex flex-col items-stretch gap-4">
    <div class="select-date-panel flex-align-center flex-justify-center flex gap-4 bg-white p-4 shadow-md">
        <ion-button
            class="var-app-light:text-primary my-0 -ml-2 h-12 text-xs font-semibold normal-case text-secondary dark:text-contrast-yellow"
            id="fromDate"
            (click)="onDateFilterClick(Direction.FROM)"
            fill="clear">
            <mat-icon class="var-app-light:text-primary mr-1 text-secondary">schedule</mat-icon>
            {{ fromDateValue.datetime | date: env.PRIMARY_DATE_FORMAT_NGPIPE }}
        </ion-button>
        <p class="p-4 text-xs font-semibold uppercase leading-4 text-grey-dark dark:text-contrast-yellow">
            {{ 'LOCAL_LABEL_TO' | translate }}
        </p>
        <ion-button
            class="var-app-light:text-primary my-0 -ml-2 h-12 text-xs font-semibold normal-case text-secondary dark:text-contrast-yellow"
            id="toDate"
            (click)="onDateFilterClick(Direction.TO)"
            fill="clear">
            <mat-icon class="var-app-light:text-primary mr-1 text-secondary">schedule</mat-icon>
            {{ toDateValue.datetime | date: env.PRIMARY_DATE_FORMAT_NGPIPE }}
        </ion-button>
    </div>

    <div class="bg-white dark:bg-contrast-black" *ngIf="(ticketsLoaded$ | async) === false; else ticketsSection">
        <div class="flex px-2 pt-2">
            <ridango-ui-skeleton-loader class="w-full" height="6rem" count="10"> </ridango-ui-skeleton-loader>
        </div>
    </div>

    <ng-template #ticketsSection>
        <div class="flex flex-col items-stretch bg-white p-4" *ngFor="let ticketsMonthGroup of tickets$ | async">
            <h2
                class="ml-1 text-xs font-semibold uppercase leading-4 text-grey-dark dark:text-contrast-yellow"
                *ngIf="ticketsMonthGroup.key"
                [class.capitalize]="env.REMOVE_UPPERCASE">
                {{ ticketsMonthGroup.key }}
            </h2>
            <rwidget-ticket-card
                *ngFor="let ticket of ticketsMonthGroup.value"
                [ticket]="ticket"
                [isHistoryTicket]="true"
                [favoriteTickets]="favoriteTickets"
                [startDateStr]="getFormattedDate(fromDateValue?.datetime)"
                [endDateStr]="getFormattedDate(toDateValue?.datetime)"
                (refreshTickets)="initializeHistoryDate()">
            </rwidget-ticket-card>
        </div>
        <p class="text-center" *ngIf="(tickets$ | async)?.length === 0">
            {{ 'DIALOG_NO_TICKETS_AVAILABLE_TITLE' | translate }}
        </p>
    </ng-template>
</div>

<ridango-ui-datetime-select
    [(ngModel)]="fromDateValue"
    [triggerId]="'fromDate'"
    [minDate]="minFromDate"
    [maxDate]="maxFromDate"
    [forceNativeDatePresentation]="true"
    (ngModelChange)="changeFromDate()"
    dateOnly="true"></ridango-ui-datetime-select>
<ridango-ui-datetime-select
    [(ngModel)]="toDateValue"
    [triggerId]="'toDate'"
    [minDate]="minToDate"
    [maxDate]="maxToDate"
    [forceNativeDatePresentation]="true"
    (ngModelChange)="changeToDate()"
    dateOnly="true"></ridango-ui-datetime-select>
